import { IEmailAttachFile } from "../Models";
import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

interface IListing {
  id: string;
  idApartment: string;
  title: string;
  description: string;
  rent: string;
  moveInDate: string;
  showings: string;
  areAvailableAppointmentsSet: boolean;
  isSelected: boolean;
  workflowType?: number;
}
interface IRentedListing {
  id: string;
  idApartment: string;
  title: string;
  description: string;
  rent: string;
  moveOutDate: string;
  showings: string;
  areAvailableAppointmentsSet: boolean;
  isSelected: boolean;
}

export async function saveListing(listing: IListing[]) {
  const url = baseUrl + "/api/Showings/SaveListings";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestBody = {
    selectedListing: listing,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }

    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function saveRentedListing(listing: IRentedListing[]) {
  const url = baseUrl + "/api/Showings/SaveRentedListings";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestBody = {
    selectedListing: listing,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }

    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

//DeleteListingAndInfo
export async function DeletedListingsAndInfo(listing: IListing[]) {
  const url = baseUrl + "/api/Showings/DeleteListingAndInfo";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestBody = {
    selectedListing: listing,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error("Failed to delete appointments");
    }

    return await response.json();
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function ListApartment(id: string) {
  const url = baseUrl + `/api/Showings/ListApartment/${id}`;
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      headers: headers,
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to delete appointments");
    }
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function fetchRentedApartmentsListingsData(listed?: boolean) {
  try {
    const token = await getTokenFromLocalStorage();
    const url = new URL(
      baseUrl + "/api/Showings/GetAllListingsAndRentedApartments",
    );
    if (typeof listed === "boolean") {
      url.searchParams.append("filterDeleted", String(!listed));
    }

    const response = await fetch(url.toString(), {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchApartmentsListingsData(filter: boolean) {
  try {
    const response = await fetch(
      baseUrl + `/api/Showings/GetAllListingsAndApartments?filter=${filter}`,
      {
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    throw error;
  }
}

export async function fetchApartmentsListingsDataWithAppointments() {
  try {
    const token = await getTokenFromLocalStorage();
    const response = await fetch(
      baseUrl + "/api/showings/GetAllListingsAndApartmentsForAppointment",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateListingToProspectiveTenants(data: any[]) {
  const url = baseUrl + "/api/Showings/UpdateListingToProspectiveTenant";
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error("Failed to save appointments");
    }

    return response;
  } catch (error: any) {
    throw new Error(`Error: ${error.message}`);
  }
}

export async function updateAutomaticEmail(apartmentId: string) {
  try {
    const token = await getTokenFromLocalStorage(); // Get token from local storage

    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    const response = await fetch(
      baseUrl + `/api/Showings/UpdateAutomaticEmail/${apartmentId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (response.ok) {
      console.log("AutomaticEmail updated to 0");
    } else {
      console.error("Failed to update AutomaticEmail", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function getapartmentdetails() {
  try {
    const token = await getTokenFromLocalStorage();

    const response = await fetch(baseUrl + `/api/Showings/ApartmentNames`, {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    // Normalize casing and fields for callers
    if (Array.isArray(data)) {
      return data.map((apt: any) => ({
        id: apt.id || apt.ID || apt.IDApartment || "",
        title: apt.title || apt.Title || "",
        description: apt.description || apt.Description || "",
        building: apt.building || apt.Building || "",
        numOfBedrooms:
          apt.numOfBedrooms ?? apt.NumOfBedrooms ?? apt.bedrooms ?? null,
        currentRent: apt.currentRent ?? apt.CurrentRent ?? apt.rent ?? null,
        workflowType: apt.workflowType ?? apt.WorkflowType ?? null,
      }));
    }

    return data;
  } catch (error) {
    throw error;
  }
}

export async function getEmailAttachFiles(id: string) {
  try {
    const response = await fetch(baseUrl + `/api/Email/GetAttachFile/${id}`, {
      headers: {
        Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
      },
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function removeEmailAttachFiles(id: string) {
  try {
    const response = await fetch(
      baseUrl + `/api/Email/DeleteAttachFile/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${await getTokenFromLocalStorage()}`,
        },
      },
    );
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function addEmailAttachFiles(data: IEmailAttachFile[]) {
  try {
    const token = await getTokenFromLocalStorage(); // Get token from local storage

    if (!token) {
      console.error("No token found. Please log in.");
      return;
    }

    const response = await fetch(baseUrl + `/api/Email/AddAttachFile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
      body: JSON.stringify(data),
    });
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
      return;
    }
    if (response.ok) {
      console.log("Attached Email uploaded successfylly");
    } else {
      console.error("Failed to save attach files", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
}
